"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    statusStyles: function() {
        return statusStyles;
    },
    Badge: function() {
        return Badge;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var statusStyles = {
    custom: {
        backgroundColor: "primary-default",
        borderColor: "primary-default",
        colorOutlineSubtle: "text-badge-outline",
        colorSolid: "text-badge-solid"
    },
    accent: {
        backgroundColor: "accent-default",
        borderColor: "accent-default",
        colorOutlineSubtle: "accent-default",
        colorSolid: "text-badge-solid"
    },
    primary: {
        backgroundColor: "primary-default",
        borderColor: "primary-default",
        colorOutlineSubtle: "primary-default",
        colorSolid: "text-badge-solid"
    },
    secondary: {
        backgroundColor: "secondary-default",
        borderColor: "secondary-default",
        colorOutlineSubtle: "secondary-default",
        colorSolid: "text-badge-solid"
    },
    info: {
        backgroundColor: "alert-inform-default",
        borderColor: "alert-inform-default",
        colorOutlineSubtle: "text-inform",
        colorSolid: "text-badge-solid"
    },
    success: {
        backgroundColor: "alert-success-default",
        borderColor: "alert-success-default",
        colorOutlineSubtle: "text-success",
        colorSolid: "text-badge-solid"
    },
    warning: {
        backgroundColor: "alert-warning-default",
        borderColor: "alert-warning-default",
        colorOutlineSubtle: "text-warning",
        colorSolid: "text-badge-solid"
    },
    error: {
        backgroundColor: "alert-error-default",
        borderColor: "alert-error-default",
        colorOutlineSubtle: "text-error",
        colorSolid: "text-badge-solid"
    }
};
var Badge = {
    baseStyle: function(param) {
        var theme = param.theme;
        return _object_spread({
            letterSpacing: "0.05em",
            borderRadius: "radii-half"
        }, theme.textStyles["text-body-floating-label-bold"]);
    },
    variants: {
        solid: function(param) {
            var status = param.status;
            return {
                backgroundColor: statusStyles[status].backgroundColor,
                color: statusStyles[status].colorSolid
            };
        },
        outline: function(param) {
            var status = param.status;
            return {
                borderColor: statusStyles[status].borderColor,
                borderWidth: "1px",
                boxShadow: "none",
                color: statusStyles[status].colorOutlineSubtle
            };
        },
        subtle: function(param) {
            var status = param.status;
            return {
                backgroundColor: "background-action-default",
                color: statusStyles[status].colorOutlineSubtle
            };
        }
    },
    defaultProps: {
        variant: "solid",
        status: "primary"
    }
};
